import { render } from "./Product.vue?vue&type=template&id=b9440b66"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"
script.render = render

export default script